export const LEGAL_COOKIE_PRIVACY_ESPOT = 'Legal_cookie_privacy_espot1';
export const TERMS_AND_CONDITIONS_ESPOT = 'TERMS_AND_CONDITIONS_espot';
export const PRIVACY_POLICY_ESPOT = 'PRIVACY_POLICY_espot';
export const PRIVACY_NOTICE_SECTION_ID = 'privacy';
export const CAT_TERMS_DEALER_PRIVACY_POLICY_ESPOT =
  'PCC_ESPOT_CAT_TERMS_DEALER_PRIVACY_POLICY_MSG';
export const PCC_ESPOT_DEALER_PRIVACY_POLICY_SNP =
  'PCC_ESPOT_DEALER_PRIVACY_POLICY_SNP';
